// What the server answers a student submission it stored with.
//
// Both save endpoints answer a stored submission with the stored record,
// `{ Request, Response: { component } }`. That is the only answer that means
// the student's work is on the server. "200" does not: the backend used to
// answer a save it would not store with 200 OK and an empty body, and both
// the page and the offline queue read that as success.
//
// Shared by the submission hook (which sees the answer with its envelope
// already taken off) and the service worker's replay (which sees it whole), so
// "saved" and "synced" cannot come to mean different things.

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function confirmsStoredSubmission(payload: unknown): boolean {
  if (!isRecord(payload)) {
    return false;
  }

  const answer = 'Response' in payload ? payload.Response : payload;

  return isRecord(answer) && isRecord(answer.component);
}
